import React from "react";
import styles from "./AccountButton.module.css";

/**
 * AccountButton is a customizable button component used for account-related actions.
 *
 * @component
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names to apply to the button.
 * @param {React.ReactNode} props.children - The content to be rendered inside the button.
 * @param {Function} [props.trackEvent] - Optional function to call for tracking analytics events before the onClick event.
 * @param {Function} [props.onClick] - Function to call when the button is clicked.
 * @param {Object} [props.rest] - Additional props spread onto the button element.
 *
 * @example
 * <AccountButton onClick={handleClick} trackEvent={trackAccountEvent}>
 *   Create your site
 * </AccountButton>
 */

const AccountButton = ({
  className,
  children,
  trackEvent = () => {},
  onClick = () => {},
  ...rest
}) => (
  <button
    className={`${styles["account-button"]}${className ? ` ${className}` : ""}`}
    onClick={() => {
      trackEvent();
      onClick();
    }}
    {...rest}
  >
    {children}
  </button>
);

export default AccountButton;
